import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { PostjsonService } from '../services/postjson.service';
import { environment } from 'src/environments/environment';
import { ToastrService } from 'ngx-toastr';
import { LoginUser } from '../model/login-user.model';
import { QuizSession } from '../model/quiz-session.model';
import { HomeService } from '../home/home.service';
import { HomeData } from '../model/home-data.model';
import { UserInfo } from '../model/user-info.model';
import { Storybook } from '../model/storybook.model';
import { StorySession } from '../model/story-session.model';
import { Student } from '../model/student.model';
import { UserAvatarResponse } from '../model/user-avatar-response.model';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { SVGToastSanitizePipe } from '../shared/extentions/svg-toast-sanitize-pipe';
import { ToastComponent, ToastPositionModel } from '@syncfusion/ej2-angular-notifications';
import { StorybookAssignmentService } from '../shared/services/storybook.assignment.service';
import { AssignStory } from '../model/story.model';
// import {  } from "../shared/services/responsiveVoice-local";
declare let responsiveVoice: any;

@Component({
  selector: 'my-assignment',
  templateUrl: './my.assignment.component.html',
  styleUrls: ['./my.assignment.component.scss'],
  providers: [SVGToastSanitizePipe]
})
export class MyAssignmentComponent implements OnInit {

  @Input()
  stories: string[]
  name: any;
  strname: any;
  showBg: boolean;
  storybooks: AssignStory[];
  storyBooksAsString: string;
  showInProgressStory: boolean = false;
  isStorybooksReady: boolean = false;
  inProgressStory: StorySession;
  showToastMessage: boolean = false;
  studentLoggedIn: boolean = false;
  isAssignmentReadingMode: boolean = false;
  safeAvatarSVG: SafeHtml;
  toastMessage: string;
  storyFinishMessage: string;
  responsiveVoiceCancelInterval: number | undefined;
  allowResponsiveVoice: boolean = false;
  @ViewChild('defaulttoast')
  public toastObj: ToastComponent;

  @ViewChild('storyEndToast')
  public storyEndToastObj: ToastComponent;

  public position: ToastPositionModel = { X: "Right" };

  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    private router: Router,
    private data: PostjsonService,
    private toast: ToastrService,
    private homeService: HomeService,
    private storybookAssignmentService: StorybookAssignmentService,
    private sanitizer: DomSanitizer,
    private svgToastSanitizePipe: SVGToastSanitizePipe
  ) {

    if (this.router.getCurrentNavigation().extras.state?.storyDone) {

      this.homeService.enableResponsiveVoice(this.responsiveVoiceCancelInterval);
      console.log("STORY DONE");
      this.allowResponsiveVoice = true;
      setTimeout(() => {
        if (this.studentLoggedIn) {
          this.storyFinishMessage = "Great job! You have finished the story Assignment";
          // this.toast.success(storyFinishMessage);
          this.storyEndToastObj.show();
          this.homeService.readMessage(this.storyFinishMessage);
        }
      }, 500);
      setTimeout(() => {
        this.allowResponsiveVoice = false;
        this.homeService.disableResponsiveVoice();
      }, 6000);
    } else {

      console.log("enable ResponsiveVoice");
      this.allowResponsiveVoice = true;
    }
  }

  ngOnInit(): void {

    //
    this.isAssignmentReadingMode = true;
    var username = localStorage.getItem("username");

    //
    setTimeout(() => {
      this.showBg = true;
    }, 3000);
    var inProgressStorySession = localStorage.getItem("inProgressStorySession");
    var inProgressStorySessionObj: StorySession;
    if (inProgressStorySession != "null" && inProgressStorySession) {
      inProgressStorySessionObj = JSON.parse(inProgressStorySession);
    }

    //
    if (username) {
      let avatarUser = JSON.parse(localStorage.getItem("avatarUser"));
      this.storybookAssignmentService.getAllStorybookAssignemntsByStudentID(avatarUser.studentId).subscribe((response: AssignStory[]) => {

        console.log(response);
        this.storybooks = response;
        this.storyBooksAsString = JSON.stringify(response);

        //
        this.homeService.sendUpdate("refreshComponent");
      },
        error => {

          console.log("error:");
          console.log(error);
          this.storybooks = [];
        });
    }

    //
    this.isStorybooksReady = true;
  }

  ngOnDestroy() {
    this.homeService.enableResponsiveVoice(this.responsiveVoiceCancelInterval);
  }

  showInProgressStoryComponent() {
    this.showInProgressStory = true;
  }

  f1(strname) {

    this.strname = strname;
    localStorage.setItem("strname", JSON.stringify(this.strname));
  }

  onBookOpen(book) {

    // store selected story name
    this.f1(book.storyName);

    // go to story
    this.router.navigate([`/story/${book.storyName}`]);
  }

  goToLevelUpComponent() {
    this.router.navigate(['/levelUp']);
  }

  showToast = (): void => {
    this.toastObj.show();
  }
}
